import { useState } from "react";
import { FileText } from "lucide-react";
import { cn } from "@tellescope/utils";

interface FileImagePreviewProps {
  src: string;
  alt: string;
}

export const FileImagePreview = ({ src, alt }: FileImagePreviewProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return <FileText className="h-4 w-4 text-muted-foreground flex-shrink-0" />;
  }

  return (
    <div className="h-10 w-10 flex-shrink-0 relative">
      {isLoading && <div className="absolute inset-0 rounded bg-muted animate-pulse" />}
      <img
        src={src}
        alt={alt}
        className={cn("h-10 w-10 object-cover rounded", isLoading && "opacity-0")}
        onLoad={() => setIsLoading(false)}
        onError={() => setHasError(true)}
      />
    </div>
  );
};
